// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"DeleteCustomerModal_buttonContainer__3Boh7","centerSpinner":"DeleteCustomerModal_centerSpinner__1NLqx"};